import React from "react";

const PersonalInformation2 = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          2. COLLECTION OF PERSONAL INFORMATION FROM SOCIAL NETWORKING SITES
        </h1>
        You may at times be permitted to log into our Platform through your
        other social networking accounts. If you do so, you must enter the email
        address and password that you use for such social networking accounts.
        We will ask that you grant us permission to access and collect your
        basic information (this includes your name, profile picture, gender,
        networks, user IDs, list of friends, date of birth, email address, and
        any other information you have set to public on your account). If you
        allow us to have access to this information, then we will retain this
        information even if you have chosen later not to make that information
        public.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        We store the information that we receive from such social networking
        sites with other information that we collect from you or receive about
        you.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Such social networking sites control the information they collect from
        you. For information about how social networking sites may use and
        disclose your information, including any information you make public,
        please consult the respective social networking sites’ privacy policy.
        We have no control over how any third-party site uses or discloses the
        personal information it collects about you.
      </p>
    </div>
  );
};

export default PersonalInformation2;
